import { api } from './client'

export type ContractDeliveryOrderStatus =
    | 'new'
    | 'confirmed'
    | 'ready_to_deliver'
    | 'in_delivery'
    | 'delivered'
    | 'delivery_failed'
    | 'cancelled'

export interface ContractDeliveryOrder {
    id: string
    order_code: string
    recipient_name: string
    recipient_phone: string
    shipping_address: string
    shipping_province?: string | null
    shipping_province_code?: string | null
    shipping_ward?: string | null
    shipping_ward_code?: string | null
    note?: string | null
    shipping_carrier_id: string
    status: ContractDeliveryOrderStatus
    created_by_id: string
    driver_assignee_id?: string | null
    delivery_trip_id?: string | null
    delivered_at?: string | null
    fail_reason?: string | null
    created_at: string
    updated_at: string
    // join-only
    created_by_name?: string
    driver_name?: string
    shipping_carrier_name?: string
}

export interface ContractDeliveryStatusLog {
    id: string
    order_id: string
    from_status?: string | null
    to_status: string
    changed_by_id: string
    note?: string | null
    created_at: string
}

export interface CreateContractDeliveryRequest {
    recipient_name: string
    recipient_phone: string
    shipping_address: string
    shipping_province?: string | null
    shipping_province_code?: string | null
    shipping_ward?: string | null
    shipping_ward_code?: string | null
    note?: string | null
    shipping_carrier_id?: string | null
}

export interface ListContractDeliveryParams {
    status?: ContractDeliveryOrderStatus
    driver_id?: string
    created_by?: string
    search?: string
    // search_address='1': search khớp cả địa chỉ giao (màn "Đơn chờ nhận").
    search_address?: '1'
    page?: number
    per_page?: number
}

export const contractDeliveryApi = {
    list: (params?: ListContractDeliveryParams) =>
        api.get<ContractDeliveryOrder[]>('/contract-delivery-orders', {
            params,
        }),
    get: (id: string) =>
        api.get<ContractDeliveryOrder>(`/contract-delivery-orders/${id}`),
    // Resolve mã GHD-... (quét QR / gõ tay của tài xế).
    lookupByCode: (code: string) =>
        api.get<ContractDeliveryOrder>('/contract-delivery-orders/lookup', {
            params: { code },
        }),
    timeline: (id: string) =>
        api.get<ContractDeliveryStatusLog[]>(
            `/contract-delivery-orders/${id}/timeline`,
        ),
    create: (data: CreateContractDeliveryRequest) =>
        api.post<ContractDeliveryOrder>('/contract-delivery-orders', data),
    update: (id: string, data: CreateContractDeliveryRequest) =>
        api.put<ContractDeliveryOrder>(`/contract-delivery-orders/${id}`, data),
    confirm: (id: string) =>
        api.post<ContractDeliveryOrder>(
            `/contract-delivery-orders/${id}/confirm`,
        ),
    cancel: (id: string, data?: { note?: string }) =>
        api.post<ContractDeliveryOrder>(
            `/contract-delivery-orders/${id}/cancel`,
            data ?? {},
        ),
    assignDriver: (id: string, data: { driver_id: string }) =>
        api.post<ContractDeliveryOrder>(
            `/contract-delivery-orders/${id}/assign-driver`,
            data,
        ),
    pickupOrder: (id: string) =>
        api.post<ContractDeliveryOrder>(
            `/contract-delivery-orders/${id}/pickup-order`,
        ),
    startDelivery: (id: string, data?: { vehicle_id?: string }) =>
        api.post<ContractDeliveryOrder>(
            `/contract-delivery-orders/${id}/start-delivery`,
            data ?? {},
        ),
    // Giao xong — KHÔNG payload tiền (khác đơn bán).
    confirmDelivery: (id: string) =>
        api.post<ContractDeliveryOrder>(
            `/contract-delivery-orders/${id}/confirm-delivery`,
        ),
    failDelivery: (id: string, data: { note: string }) =>
        api.post<ContractDeliveryOrder>(
            `/contract-delivery-orders/${id}/fail-delivery`,
            data,
        ),
}
